import PropTypes from 'prop-types';
import { ChangeEvent } from 'react';
import { StyledTextarea } from './styles';

interface TextareaInterface {
  value: string;
  placeholder?: string;
  onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  darkBorder?: boolean;
  height?: number;
  maxLength?: number;
  disabled?: boolean;
}


export default function Textarea({
  value,
  placeholder,
  onChange,
  darkBorder,
  height,
  maxLength,
  disabled,
}: TextareaInterface) {
  return (
    <StyledTextarea
      placeholder={placeholder}
      onChange={onChange}
      darkBorder={darkBorder}
      height={height}
      value={value}
      maxLength={maxLength ?? undefined}
      disabled={disabled}
    />
  );
}

Textarea.propTypes = {
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.string.isRequired,
  darkBorder: PropTypes.bool,
  height: PropTypes.number,
  // error: PropTypes.string,
};

Textarea.defaultProps = {
  darkBorder: false,
  height: 150,
  disabled: false,
  // error: '',
};
